import { render } from "./CategoriesBox.vue?vue&type=template&id=6477adff&scoped=true&ts=true"
import script from "./CategoriesBox.vue?vue&type=script&lang=ts"
export * from "./CategoriesBox.vue?vue&type=script&lang=ts"

import "./CategoriesBox.vue?vue&type=style&index=0&id=6477adff&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6477adff"]])

export default __exports__